import { useMediaQuery } from '@mui/material'
import {
  THREADS_SECTION_PREVIEW_LIMIT_SHORT,
  THREADS_SECTION_PREVIEW_LIMIT_TALL,
  THREADS_SECTION_PREVIEW_MIN_HEIGHT_PX,
} from './threadsSectionConstants.js'

export function useThreadsSectionPreviewLimit() {
  const isTallViewport = useMediaQuery(
    `(min-height: ${THREADS_SECTION_PREVIEW_MIN_HEIGHT_PX}px)`,
  )

  return isTallViewport
    ? THREADS_SECTION_PREVIEW_LIMIT_TALL
    : THREADS_SECTION_PREVIEW_LIMIT_SHORT
}
